import { render, staticRenderFns } from "./activity-single.vue?vue&type=template&id=0df08876&"
import script from "./activity-single.vue?vue&type=script&lang=ts&"
export * from "./activity-single.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports